export default __webpack_public_path__ + "static/media/Top10.004cc819.svg";